export default __webpack_public_path__ + "static/media/logo03.10354602.svg";